"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _Icons = _interopRequireDefault(require("../../primitives/Icons"));
var _UptimeBar = _interopRequireDefault(require("../UptimeBar"));
var _Tag = _interopRequireDefault(require("../Tag"));
var _Dot = _interopRequireDefault(require("../../primitives/Dot"));
var _Line = _interopRequireDefault(require("../../ui/Line"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const Row = _ref => {
  let {
    name,
    type,
    value,
    protocol,
    status,
    onClick,
    style,
    group,
    isOpen,
    height = '48px'
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex align-items-center pl-1em pr-1em bg-light border font-weight-400 font-size-14px overflow-hidden".concat(type === 'group' ? ' bg-gradient after-glow justify-content-space-between hoverable' : ' justify-content-space-between'),
    style: _objectSpread({
      height: height,
      lineHeight: height
    }, style),
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement(_Dot.default, {
    status: status,
    className: "mr-1em"
  }), type === 'group' && /*#__PURE__*/_react.default.createElement(_Icons.default, {
    className: "mr-05em",
    name: "folder"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex align-items-center",
    style: {
      width: '200px'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "hoverable underline white-space-no-wrap mr-1em"
  }, name), type === 'group' && /*#__PURE__*/_react.default.createElement(_Tag.default, null, group.monitors.length, " monitors"))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '160px'
    }
  }, !!value && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex color-text-secondary justify-content-end"
  }, value)), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex align-items-center justify-content-center",
    style: {
      width: '30px'
    }
  }, protocol === 'browser' && /*#__PURE__*/_react.default.createElement(_Icons.default, {
    name: "firefox"
  }), protocol === 'http' && /*#__PURE__*/_react.default.createElement(_Tag.default, null, /*#__PURE__*/_react.default.createElement(_Icons.default, {
    width: "24px",
    height: "24px",
    name: "http"
  }))), type !== 'group' && /*#__PURE__*/_react.default.createElement(_Line.default, null), type === 'monitor' && /*#__PURE__*/_react.default.createElement(_UptimeBar.default, null), type === 'group' && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-content-end hoverable"
  }, /*#__PURE__*/_react.default.createElement(_Icons.default, {
    size: "small",
    name: isOpen ? 'chevronopen' : 'chevronclosed'
  })), type === 'monitor' && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-content-end"
  }, /*#__PURE__*/_react.default.createElement(_Icons.default, {
    name: "greenlock"
  })));
};
const MonitorList = _ref2 => {
  let {
    groups
  } = _ref2;
  const [open, setOpen] = _react.default.useState(['grp_12345']);

  // const open = ['grp_12345'];
  const toggle = uuid => !open.includes(uuid) ? setOpen([...open, uuid]) : setOpen(open.filter(id => id !== uuid));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, groups.map(group => /*#__PURE__*/_react.default.createElement("div", {
    key: group.uuid,
    className: "hpd border-list mb-075em"
  }, /*#__PURE__*/_react.default.createElement(Row, {
    type: "group",
    name: group.name,
    status: group.status,
    onClick: () => toggle(group.uuid),
    style: {
      borderBottomLeftRadius: open.includes(group.uuid) ? '0px' : '6px',
      borderBottomRightRadius: open.includes(group.uuid) ? '0px' : '6px'
    },
    group: group,
    isOpen: open.includes(group.uuid)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "border-list monitor-list",
    style: {
      height: open.includes(group.uuid) ? 'auto' : '0px'
    }
  }, group.monitors.map(monitor => /*#__PURE__*/_react.default.createElement(Row, {
    key: monitor.uuid,
    type: "monitor",
    name: monitor.name,
    value: monitor.value,
    protocol: monitor.protocol,
    status: monitor.status,
    style: {
      opacity: open.includes(group.uuid) ? '1' : '0'
    }
  }))))));
};
var _default = exports.default = MonitorList;